import { render, staticRenderFns } from "./ProductAutocomplete.vue?vue&type=template&id=fd24f2a2&"
import script from "./ProductAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ProductAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports